import { render, staticRenderFns } from "./TabUpGift.vue?vue&type=template&id=a29f0b08&"
import script from "./TabUpGift.vue?vue&type=script&lang=js&"
export * from "./TabUpGift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports